{
  "conversations": {
    "conversationsApp": "Conversations App",
    "locationId": "Location ID",
    "idToken": "ID Token",
    "conversationRoutes": "Conversation Routes",
    "conversationProviders": "Conversation Providers",
    "viewTheListOfConversation": "View the list of conversation custom providers added to the account here.",
    "logo": "Logo",
    "name": "Name",
    "alias": "Alias",
    "type": "Type"
  }
}
